export default __webpack_public_path__ + "static/media/joseph.b4e202c4.jpg";